import { Link as RouterLink } from 'react-router-dom';
import {Pagination} from "@mui/lab";
// material
import {useTranslation} from "react-i18next";
import {useEffect, useState} from "react";
import { Grid, Button, Container, Stack, Typography } from '@mui/material';
import {FadeLoader} from "react-spinners";
// components
import Page from '../components/Page';

import Iconify from '../components/Iconify';

import SortDropdown from "../components/SortDropdown";
import useQuery from "../hooks/useQuery";
import SearchModel from "../components/SearchModel";
import CollaboratorCard from '../sections/@dashboard/collaborators/CollaboratorCard';




export default function Collaborators() {
  const { t } = useTranslation();

  const [collaborators ,setCollaborators] = useState([]);
  const [pagination, setPagination] = useState({total: 0, per_page: 0, current_page: 1, last_page: 1});
  const [page, setPage] = useState(1);
  const [filterEvent ,setfilterEvent] = useState("");
  const [sort ,setSort] = useState('desc');
  const [isLoading, setIsLoading] = useState(true);

  const fetchData = useQuery();
  const handleChange = (event, value) => {
    setPage(value)
  }

  useEffect(() => {
    const delayDebounceFn = setTimeout(async () => {
      setIsLoading(true)
      await fetchData('collaborators', filterEvent, sort, setCollaborators, 'created_at', setPagination, page)
      setIsLoading(false)
    }, 500)
    return () => clearTimeout(delayDebounceFn)
  }, [filterEvent, sort, page])

  return (
      <Page title="Dashboard: Collaborators">
        <Container>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
            <Typography variant="h4" gutterBottom>
              {t('Collaborators')}
            </Typography>
            <Button variant="contained" component={RouterLink} to="/dashboard/collaborators/create" startIcon={<Iconify icon="eva:plus-fill" />}>
              {t('Create_Collaborator')}
            </Button>
          </Stack>

          <Stack mb={5} direction="row" alignItems="center" justifyContent="space-between">
            <SearchModel filterName={filterEvent} onFilterName={setfilterEvent} placeHolder={t("Search_collaborators")} />
            <SortDropdown sort={sort} setSort={setSort} />
          </Stack>

          <Grid container spacing={3}>
            {isLoading ? (<FadeLoader
                color={'blue'}
                loading={isLoading}
                cssOverride={{
                  margin: '0 auto',
                }}
                size={50}
            />) : (
                collaborators.map((collaborator, index) => (
                  <CollaboratorCard key={collaborator.id} collaborator={collaborator} index={index} />
              )
                )) }

          </Grid>
          <div style={{display: "flex", alignItems: 'center', justifyContent: 'center', marginTop: '20px'}}>
            <Pagination count={pagination.last_page} page={page}  variant="outlined" shape="rounded" onChange={handleChange} />
          </div>
        </Container>
      </Page>
  );
}
